module.exports = {
      id: "speaker-usage",
      viewBox: "0 0 15 12",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#speaker",
      toString: function () {
        return this.url;
      }
    }